import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../../constants/pages-and-paths';
import {OuterPagesGuardService} from '../../../../guards/outer-pages-guard.service';
import {SingleBlogComponent} from './single-blog.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.landingSingleBlog.pageInRouting,
    data: {data: PAGES_AND_PATHS.landingSingleBlog},
    component: SingleBlogComponent,
    canActivate: [OuterPagesGuardService],
    loadChildren: () => import('./single-blog.module').then(m => m.SingleBlogModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SingleBlogRoutingModule { }
